export const messages = {
  en: {
    roomOweFeeCallable: {
      title: 'Urge Arrears',
      callableWay: 'Urge Method',
      selectCallableWay: 'Please select urge method',
      callableFees: 'Urge Fees', 
      remark: 'Urge Remark',
      inputRemark: 'Please input remark',
      callableWayRequired: 'Urge method is required',
      fetchFeeError: 'Failed to get fee list'
    }
  },
  zh: {
    roomOweFeeCallable: {
      title: '催缴欠费',
      callableWay: '催缴方式',
      selectCallableWay: '请选择催缴方式',
      callableFees: '催缴费用',
      remark: '催缴说明',
      inputRemark: '请输入备注',
      callableWayRequired: '催缴方式不能为空',
      fetchFeeError: '获取费用列表失败'
    }
  }
}